export default __webpack_public_path__ + "static/media/rectangle_purple.990c0d02.svg";